import { useState, useEffect } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [passwort, setPasswort] = useState('');
  const [zeigePasswort, setZeigePasswort] = useState(false);
  const [displayName, setDisplayName] = useState('');
  const [istRegistrierung, setIstRegistrierung] = useState(false);
  const [fehler, setFehler] = useState('');
  const [laden, setLaden] = useState(false);
  
  const navigate = useNavigate();
  const { login, signup, currentUser } = useAuth();
  const location = useLocation(); // ← NEU

  // Prüfe ob /register aufgerufen wurde
  useEffect(() => {
    if (location.pathname === '/register') {
      setIstRegistrierung(true);
    }
  }, [location]); // ← NEU

  // Wer schon angemeldet ist, muss das Login-Formular nicht sehen
  if (currentUser) {
    return <Navigate to="/saison-auswahl" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFehler('');
    
    if (!email || !passwort) {
      setFehler('Bitte alle Felder ausfüllen!');
      return;
    }
    
    if (istRegistrierung && !displayName) {
      setFehler('Bitte Anzeigenamen eingeben!');
      return;
    }
    
    if (passwort.length < 6) {
      setFehler('Passwort muss mindestens 6 Zeichen lang sein!');
      return;
    }
    
    setLaden(true);
    
    try {
      if (istRegistrierung) {
        // Registrierung
        await signup(email, passwort, displayName);
        console.log('Registrierung erfolgreich!');
      } else {
        // Login
        await login(email, passwort);
        console.log('Login erfolgreich!');
      }
      
      navigate('/saison-auswahl');
    } catch (error) {
      console.error('Fehler:', error);
      
      // Deutsche Fehlermeldungen
      if (error.code === 'auth/email-already-in-use') {
        setFehler('Diese E-Mail ist bereits registriert!');
      } else if (error.code === 'auth/invalid-email') {
        setFehler('Ungültige E-Mail Adresse!');
      } else if (error.code === 'auth/user-not-found') {
        setFehler('Kein Benutzer mit dieser E-Mail gefunden!');
      } else if (error.code === 'auth/wrong-password') {
        setFehler('Falsches Passwort!');
      } else if (error.code === 'auth/invalid-credential') {
        setFehler('Ungültige Anmeldedaten!');
      } else {
        setFehler('Ein Fehler ist aufgetreten: ' + error.message);
      }
    }
    
    setLaden(false);
  };

  return (
    <div style={{ 
      maxWidth: '400px', 
      margin: '100px auto', 
      padding: '30px',
      border: '2px solid #333',
      borderRadius: '10px',
      textAlign: 'center'
    }}>
      <h1>🏈 NFL Tippspiel</h1>
      <h2>{istRegistrierung ? 'Registrierung' : 'Anmeldung'}</h2>
      
      {fehler && (
        <div style={{
          backgroundColor: '#f8d7da',
          color: '#721c24',
          padding: '10px',
          borderRadius: '5px',
          marginBottom: '15px'
        }}>
          {fehler}
        </div>
      )}
      
      <form onSubmit={handleSubmit}>
        {istRegistrierung && (
          <input 
            type="text"
            placeholder="Anzeigename"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              margin: '10px 0',
              fontSize: '16px',
              borderRadius: '5px',
              border: '1px solid #ccc'
            }}
          />
        )}
        
        <input 
          type="email"
          placeholder="E-Mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{
            width: '100%',
            padding: '10px',
            margin: '10px 0',
            fontSize: '16px',
            borderRadius: '5px',
            border: '1px solid #ccc',
            boxSizing: 'border-box'  // ← HINZUFÜGEN!
          }}
        />
        
        <div style={{ position: 'relative', margin: '10px 0' }}>
          <input 
            type={zeigePasswort ? 'text' : 'password'}
            placeholder="Passwort (min. 6 Zeichen)"
            value={passwort}
            onChange={(e) => setPasswort(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              paddingRight: '50px',
              fontSize: '16px',
              borderRadius: '5px',
              border: '1px solid #ccc',
              boxSizing: 'border-box'  // ← WICHTIG!
            }}
          />
          <button
            onClick={() => setZeigePasswort(!zeigePasswort)}
            type="button"
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: '18px',
              padding: '5px'
            }}
          >
            {zeigePasswort ? '🙈' : '👁️'}
          </button>
        </div>
        
        <button 
          type="submit"
          disabled={laden}
          style={{
            width: '100%',
            padding: '12px',
            marginTop: '20px',
            fontSize: '18px',
            backgroundColor: laden ? '#6c757d' : '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: laden ? 'not-allowed' : 'pointer'
          }}
        >
          {laden ? 'Bitte warten...' : (istRegistrierung ? 'Registrieren' : 'Anmelden')}
        </button>
      </form>
      
      <p style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
        {istRegistrierung ? 'Schon einen Account?' : 'Noch kein Account?'}
        {' '}
        <button 
          onClick={() => {
            setIstRegistrierung(!istRegistrierung);
            setFehler('');
          }}
          style={{
            background: 'none',
            border: 'none',
            color: '#007bff',
            cursor: 'pointer',
            textDecoration: 'underline',
            fontSize: '14px'
          }}
        >
          {istRegistrierung ? 'Zum Login' : 'Jetzt registrieren'}
        </button>
      </p>
    </div>
  );
}

export default LoginPage;